import PropTypes from 'prop-types';

export const RCT = 'rct';
export const DAZE = 'daze';
// DEPRECATED: remove once trc -> tro rename is completed
export const TRC = 'trc';

export const ACCURACY = 'accuracy';
export const FLUENCY = 'fluency';
export const COMPREHENSION = 'comprehension';
export const FLUENCY_COMPREHENSION = 'flu_comp';
export const MEASURE_TYPE = { ACCURACY, FLUENCY, COMPREHENSION };

export const VOCAB = {
    ASSESSMENT: 'vocab',
    FULL_NAME: 'Vocabulary',
    FITB: 'fitb',
    TQVM: 'tqvm',
    BD: 'bd',
    LANGUAGE: 'eng',
    MEASURES: ['TQVM', 'FITB', 'BD'],
};

export const VOCAB_SPA = {
    ASSESSMENT: 'vocab',
    FULL_NAME: 'Vocabulario',
    FITB: 'FITB-Spa',
    TQVM: 'TQVM-Spa',
    BD: 'BD-Spa',
    LANGUAGE: 'spa',
    MEASURES: ['TQVM-Spa', 'FITB-Spa', 'BD-Spa'],
};

export const SPELLING = {
    ASSESSMENT: 'spelling',
    FULL_NAME: 'Spelling',
    SPELLING: 'SPELLING',
    LANGUAGE: 'eng',
    MEASURES: ['SPELLING'],
    MEASURE_API_KEY: 'Spelling',
};

export const SPELLING_SPA = {
    ASSESSMENT: 'spelling',
    FULL_NAME: 'Ortografía',
    SPELLING: 'SPELLING-Spa',
    LANGUAGE: 'spa',
    MEASURES: ['SPELLING-Spa'],
    MEASURE_API_KEY: 'Spelling',
};

export const MAZE = {
    ASSESSMENT: 'maze',
    NAME: 'Maze',
    MEASURE: 'MAZE',
};

export const CLPL = {
    ASSESSMENT: 'cual-palabra',
    NAME: '¿Cuál palabra?',
    MEASURE: 'CLPL',
};

export const RAN = {
    FULL_NAME: 'RAN',
    MEASURE: 'ran',
    NUMBERS: 'numbers',
};

export const IPS = {
    ASSESSMENT: 'ips',
};

export const LN = {
    ASSESSMENT: 'ln',
    MEASURE: 'LNF',
    NAME: 'LN',
};

export const TRO = {
    ASSESSMENT: 'tro',
    MEASURE: 'TRO',
};

export const LC = {
    ASSESSMENT: 'lc',
    MEASURE: 'LC',
    LISTEN_COMP: 'LISTEN-COMP',
    FULL_NAME: 'Listening Comprehension'
};

export const WR = {
    KEY: 'wr',
    MEASURE: 'WR',
    FULL_NAME: 'Word Reading'
};

export const DECODING_ONLINE = {
    ASSESSMENT: 'decoding',
    FULL_NAME: 'Decoding',
    MEASURES: [WR.MEASURE],
};

export const NW = {
    ASSESSMENT: 'nw',
};

export const PB = {
    ASSESSMENT: 'pb',
};

export const SKILLS = {
    ADVANCED_PHONICS: 'Advanced Phonics, Oral Reading Accuracy, Fluency, Comprehension',
    COMP: 'Comprehension',
};

export const ASSESSMENT_TYPE = {
    BM: 'BM', // Benchmark
    PM: 'PM', // Progress Monitoring
};

export const COMPREHENSION_MEASURE = {
    DAZE: 'DAZE',
    MAZE: MAZE.MEASURE,
    CLPL: CLPL.MEASURE,
};

export const OBSERVATIONAL_MEASURE = {
    DORF: 'DORF',
    DAZE: 'DAZE',
};

export const MEASURES_CONFIG = {
    RCT_FORM: 'rctForm',
};

export const ASSESSMENT_MODALITY = {
    ONLINE: 'online',
    OFFLINE: 'offline',
};

export const DATA_SOURCE = {
    ONLINE: 'online',
    SECURE_ASSESSMENT: 'secure-assessment',
};

export const FLUENCY_AUTO_ADVANCE_SEGMENTS_COUNT = 5;

export const DISCONTINUE_RULE = {
    RCT: {
        passageIndex: 1,
        segmentIndex: 3,
        incorrectQuestions: 3,
    },
};

export const FLUENCY_PASSAGE_QUESTION_SKIPPED = {
    index: -1,
    responseId: null,
    outcome: 'SK',
};

export const RESULT_RESPONSE_OUTCOME = {
    CORRECT: 'C',
    NOT_CORRECT: 'NC',
    SKIPPED: 'SK',
    NOT_ATTEMPTED: 'NA',
};

export const FLUENCY_READING_REMINDER_TEXT = 'Read before you click.';

/* TRC */
export const TRC_UNCLASSIFIED_RESPONSE_INDEX = -1;

export const TRC_QUESTION_TYPES = {
    MULTI_CHOICE: 'MC', // multi-choice
    MULTIPLE_CORRECT_ANSWERS: 'MCA', // multiple correct answers
    CLOZE_DROPDOWN: 'CD', // cloze dropdown
    CLASSIFICATION: 'CL', // classification
    CLASSIFICATION_2X2: 'CL2X2', // classification 2 by 2
    CLASSIFICATION_1X3: 'CL3X1', // classification 1 by 3
};

export const TRC_QUESTION_CONSTANTS = {
    CLASSIFICATION: 'classification',
    MULTIPLE_CORRECT_ANSWERS: 'multipleCorrectAnswers',
    COMPREHENSION_ANSWER: 'comprehensionAnswer',
    FILL: 'fill',
};

export const TRC_ANSWER_TYPES = {
    ONE_ANSWER: 'one',
    TWO_ANSWERS: 'two',
};

export const PLAYLIST_ITEM_SHAPE = PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    startingURL: PropTypes.string,
    status: PropTypes.string,
    language: PropTypes.string,
    measure: PropTypes.string,
});

export const AR_SMALL = 'ar';
